import "./PatientStories.css";
import story1 from "./media/ps1.JPG";
import story2 from "./media/ps2.JPG";
import story3 from "./media/ps3.JPG";
import story4 from "./media/ps4.JPG";
import story5 from "./media/ps5.JPG";
import story6 from "./media/ps6.jpg";
import story7 from "./media/ps7.JPG";
import story8 from "./media/ps8.JPG";
import story9 from "./media/ps9.jpg";
import story10 from "./story10.jpg";
import story11 from "./story11.jpg";
import story12 from "./story12.jpg";

export default function PatientStories() {
  const stories = [
    { img: story1, user: "antoni" },
    { img: story2, user: "makiryoke" },
    { img: story3, user: "oliviawilde" },
    { img: story4, user: "carlylevine" },

    { img: story5, user: "davidp" },
    { img: story6, user: "annalise" },
    { img: story7, user: "rohitn" },
    { img: story8, user: "mariah" },

    { img: story9, user: "vidp" },
    // { img: story10, user: "alise" },
    // { img: story11, user: "ohitn" },
    // { img: story12, user: "ariah" },
  ];

  return (
    <section className="stories-section">
      <h2 className="stories-title">Moments They Shared, Smiles They Loved</h2>
      <p>Behind every smile is a story and our patients proudly share theirs. These photos and moments showcase the confidence, comfort, and happiness they experienced during their treatment. Whether it’s a routine cleaning, a full smile makeover, or just a warm interaction with our team, each story reflects the genuine care we aim to provide. These shared experiences celebrate transformation, trust, and the small yet meaningful moments that make every visit special.</p>
      
      <div className="stories-grid">
        {stories.map((item, index) => (
          <div className="story-card" key={index}>
            {/* <div className="story-user">{item.user}</div> */}
            <img src={item.img} alt="patient story" />
          </div>
        ))}
      </div>
    </section>
  );
}
